import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

import { ref, computed, onMounted } from 'vue';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { getSameCategoryItems, type SameCategoryItem } from '@/js/lib/api/item';
import { category as categoryData } from '@/js/data/category';


export default /*@__PURE__*/_defineComponent({
  __name: 'SameCategoryItems',
  props: {
    categoryId: {},
    isVintage: { type: Boolean },
    price: {}
  },
  setup(__props: any) {

const props = __props;
const rootEl = ref<HTMLDivElement>();
const items = ref<SameCategoryItem[]>([]);
const category = categoryData({ categoryId: props.categoryId });
const categoryName = category?.name || '';
const linkToCategory = computed(() => {
  let path = '/listing';
  if (category) {
    if (category.parentCategoryId) {
      const parent = categoryData({ categoryId: category.parentCategoryId })!;
      path = `/category/${parent.slug}/${category.slug}`;
    } else {
      path = `/category/${category.slug}`;
    }
  }

  if (props.isVintage) {
    path += '?vintage=on';
  }

  return path;
});
const itemImageUrl = (imagePath: string) => dynamicImageUrl(imagePath, 310, 310);
const loadItems = async () => {
  const data = await getSameCategoryItems({ categoryId: props.categoryId, price: props.price, isVintage: props.isVintage });
  items.value = data.slice(0, 18);
};

onMounted(() => {
  if ('IntersectionObserver' in window) {
    const rootElObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems();
          rootElObserver.unobserve(rootEl.value!);
        }
      });
    });
    rootElObserver.observe(rootEl.value!);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl
  }, [
    (items.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", {
            class: _normalizeClass(_ctx.$style.title)
          }, "カテゴリー「" + _toDisplayString(_unref(categoryName)) + "」の" + _toDisplayString(_ctx.isVintage ? 'アンティーク・ヴィンテージ商品' : '作品'), 3),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("ul", {
            class: _normalizeClass(_ctx.$style.list)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.itemId
              }, [
                _createElementVNode("a", {
                  href: `/listing/item/${item.itemId}`
                }, [
                  _createElementVNode("img", {
                    src: itemImageUrl(item.imagePath),
                    alt: item.title,
                    width: "155",
                    height: "155",
                    loading: "lazy"
                  }, null, 8, _hoisted_3)
                ], 8, _hoisted_2),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.name)
                }, [
                  _createElementVNode("a", {
                    href: `/listing/item/${item.itemId}`
                  }, _toDisplayString(item.title), 9, _hoisted_4)
                ], 2),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", null, "¥" + _toDisplayString(item.price.toLocaleString()), 1)
              ]))
            }), 128))
          ], 2),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.$style.more)
          }, [
            _createElementVNode("a", { href: linkToCategory.value }, "もっと見る", 8, _hoisted_5)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})